import { render, staticRenderFns } from "./ModalDescV2.vue?vue&type=template&id=21a9cd78&scoped=true&"
import script from "./ModalDescV2.vue?vue&type=script&lang=js&"
export * from "./ModalDescV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalDescV2.vue?vue&type=style&index=0&id=21a9cd78&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9cd78",
  null
  
)

export default component.exports